(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'WalletKit-common'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'WalletKit-common'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'WalletKit-common'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'WalletKit-common'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'WalletKit-common'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'WalletKit-common'.");
    }
    globalThis['WalletKit-common'] = factory(typeof globalThis['WalletKit-common'] === 'undefined' ? {} : globalThis['WalletKit-common'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlinx-serialization-kotlinx-serialization-json']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.ba;
  var initMetadataForCompanion = kotlin_kotlin.$_$.f9;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var Long = kotlin_kotlin.$_$.pc;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var initMetadataForObject = kotlin_kotlin.$_$.j9;
  var VOID = kotlin_kotlin.$_$.b;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var objectCreate = kotlin_kotlin.$_$.aa;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var equalsLong = kotlin_kotlin.$_$.y7;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(WalletDto, 'WalletDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TopUpWalletRequestDto, 'TopUpWalletRequestDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  //endregion
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.wallet.WalletDto', this, 2);
    tmp0_serialDesc.tt('currencyIso3', false);
    tmp0_serialDesc.tt('balanceCents', false);
    this.w23_1 = tmp0_serialDesc;
  }
  protoOf($serializer).x23 = function (encoder, value) {
    var tmp0_desc = this.w23_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.y23_1);
    tmp1_output.qn(tmp0_desc, 1, value.z23_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer).fj = function (encoder, value) {
    return this.x23(encoder, value instanceof WalletDto ? value : THROW_CCE());
  };
  protoOf($serializer).gj = function (decoder) {
    var tmp0_desc = this.w23_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.lm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.lm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return WalletDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer).ej = function () {
    return this.w23_1;
  };
  protoOf($serializer).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function WalletDto_init_$Init$(seen0, currencyIso3, balanceCents, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance().w23_1);
    }
    $this.y23_1 = currencyIso3;
    $this.z23_1 = balanceCents;
    return $this;
  }
  function WalletDto_init_$Create$(seen0, currencyIso3, balanceCents, serializationConstructorMarker) {
    return WalletDto_init_$Init$(seen0, currencyIso3, balanceCents, serializationConstructorMarker, objectCreate(protoOf(WalletDto)));
  }
  function WalletDto(currencyIso3, balanceCents) {
    this.y23_1 = currencyIso3;
    this.z23_1 = balanceCents;
  }
  protoOf(WalletDto).toString = function () {
    return 'WalletDto(currencyIso3=' + this.y23_1 + ', balanceCents=' + this.z23_1.toString() + ')';
  };
  protoOf(WalletDto).hashCode = function () {
    var result = getStringHashCode(this.y23_1);
    result = imul(result, 31) + this.z23_1.hashCode() | 0;
    return result;
  };
  protoOf(WalletDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WalletDto))
      return false;
    if (!(this.y23_1 === other.y23_1))
      return false;
    if (!equalsLong(this.z23_1, other.z23_1))
      return false;
    return true;
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.wallet.TopUpWalletRequestDto', this, 2);
    tmp0_serialDesc.tt('paymentMethodRef', false);
    tmp0_serialDesc.tt('amountCents', false);
    this.a24_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).b24 = function (encoder, value) {
    var tmp0_desc = this.a24_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.c24_1);
    tmp1_output.qn(tmp0_desc, 1, value.d24_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_0).fj = function (encoder, value) {
    return this.b24(encoder, value instanceof TopUpWalletRequestDto ? value : THROW_CCE());
  };
  protoOf($serializer_0).gj = function (decoder) {
    var tmp0_desc = this.a24_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.lm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.lm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return TopUpWalletRequestDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).ej = function () {
    return this.a24_1;
  };
  protoOf($serializer_0).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function TopUpWalletRequestDto_init_$Init$(seen0, paymentMethodRef, amountCents, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_0().a24_1);
    }
    $this.c24_1 = paymentMethodRef;
    $this.d24_1 = amountCents;
    return $this;
  }
  function TopUpWalletRequestDto_init_$Create$(seen0, paymentMethodRef, amountCents, serializationConstructorMarker) {
    return TopUpWalletRequestDto_init_$Init$(seen0, paymentMethodRef, amountCents, serializationConstructorMarker, objectCreate(protoOf(TopUpWalletRequestDto)));
  }
  function TopUpWalletRequestDto(paymentMethodRef, amountCents) {
    this.c24_1 = paymentMethodRef;
    this.d24_1 = amountCents;
  }
  protoOf(TopUpWalletRequestDto).toString = function () {
    return 'TopUpWalletRequestDto(paymentMethodRef=' + this.c24_1 + ', amountCents=' + this.d24_1.toString() + ')';
  };
  protoOf(TopUpWalletRequestDto).hashCode = function () {
    var result = getStringHashCode(this.c24_1);
    result = imul(result, 31) + this.d24_1.hashCode() | 0;
    return result;
  };
  protoOf(TopUpWalletRequestDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TopUpWalletRequestDto))
      return false;
    if (!(this.c24_1 === other.c24_1))
      return false;
    if (!equalsLong(this.d24_1, other.d24_1))
      return false;
    return true;
  };
  function get_walletKitJson() {
    _init_properties_WalletKitHttpClient_kt__skckvy();
    return walletKitJson;
  }
  var walletKitJson;
  function walletKitJson$lambda($this$Json) {
    _init_properties_WalletKitHttpClient_kt__skckvy();
    $this$Json.a14_1 = true;
    return Unit_instance;
  }
  var properties_initialized_WalletKitHttpClient_kt_hpwtb4;
  function _init_properties_WalletKitHttpClient_kt__skckvy() {
    if (!properties_initialized_WalletKitHttpClient_kt_hpwtb4) {
      properties_initialized_WalletKitHttpClient_kt_hpwtb4 = true;
      walletKitJson = Json(VOID, walletKitJson$lambda);
    }
  }
  //region block: post-declaration
  protoOf($serializer).ju = typeParametersSerializers;
  protoOf($serializer_0).ju = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = TopUpWalletRequestDto;
  _.$_$.b = WalletDto;
  _.$_$.c = get_walletKitJson;
  //endregion
  return _;
}));

